export default __webpack_public_path__ + "static/media/fig-16-shear-horizontal-ps.bf284f19.png";